import React, { Component } from 'react';
import './ResultMenuBar.css'
import downloadicon from './img/download.svg';

export default class ResultMenuBar extends Component {
    handleOnClick = (section) => (e) => {
        this.props.onMenuChange(section);
    }
    handleDownloadCSV = () => {
        this.props.onDownloadCSV();
    }
    render() {
        const section = this.props.section;
        return (
            <div className="ResultMenuBar">
                <ul>
                    <li className={section==="list" ? "selected" : ""} onClick={this.handleOnClick('list')}>該当銘柄リスト</li>
                    <li className={section==="analysis" ? "selected" : ""} onClick={this.handleOnClick('analysis')}>該当銘柄詳細分析</li>
                </ul>
                <div className="download" onClick={this.handleDownloadCSV} >
                    <img src={downloadicon} width="10" height="12" alt="Download CSV" />
                    &nbsp;CSVダウンロード
                </div>
            </div>
        );
    }
}